export default "__VITE_ASSET__DwHgZvYG__"